<script lang="ts">
    import { twMerge } from "tailwind-merge"

    let className = ""
    export { className as class }
</script>

<h2 class={twMerge("popup-heading", className)} {...$$restProps}>
    <slot />
</h2>

<!-- <hr class="mb-4" /> -->

<style>
    .popup-heading {
        margin: 0;
        color: var(--color-grey-900);
        font-family: Lora, ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
        font-size: 1.45rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1.25;
    }

    :global(.darkmode) .popup-heading {
        color: var(--color-grey-50);
    }
</style>
